import { Location } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const sessionId = uuidv4();

export interface IFullscreenEntry {
  sessionId: string;
  pageKey: string;
  sourceKey: string;
}

export const getFullscreenEntry = (location: Pick<Location<unknown>, "state">): IFullscreenEntry | undefined => {
  const state = location.state;

  if (!state || typeof state !== "object" || !("gifFullscreen" in state)) {
    return undefined;
  }

  const entry = state.gifFullscreen;

  if (!entry || typeof entry !== "object" ||
    !("pageKey" in entry) || typeof entry.pageKey !== "string" ||
    !("sourceKey" in entry) || typeof entry.sourceKey !== "string" ||
    !("sessionId" in entry) || entry.sessionId !== sessionId) {
    return undefined;
  }

  return entry as IFullscreenEntry;
};

export const getPageKey = (location: Location<unknown>): string =>
  getFullscreenEntry(location)?.pageKey ?? location.key;

export const createFullscreenEntry = (pageKey: string, sourceKey: string): IFullscreenEntry => ({
  sessionId,
  pageKey,
  sourceKey,
});
